<template>
  <transition name="fade" @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      class="message"
      :class="[`${type}`]"
      @mouseleave="startTimer"
      @mouseenter="clearTimer"
    >
     <!-- message定义基础样式类， type接受options中值，动态修改样式 -->
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Message',
  data () {
    return {
      visible: false,
      type: 'info',
      message: '',
      duration: 2000,
      timer: null
    }
  },
  mounted () {
    this.setTimer() // 组件挂载的时候开始计时，计时完成移除
  },
  methods: {
    setTimer () { // 组件停留时间duration
      this.timer = setTimeout(() => {
        this.close()
      }, this.duration)
    },
    close () {
      this.visible = false
      clearTimeout(this.timer)
    },
    clearTimer () { // 鼠标移入提醒框时，清除定时器，提醒框持久化显示
      console.log('清除定时器，不会自动消失')
      clearTimeout(this.timer)
    },
    startTimer () { // 鼠标离开提醒框，定时器开始计时
      console.log('开始定时器')
      this.setTimer()
    },
    handleAfterLeave () { // 移除动画执行完成后，销毁组件，并将其从父节点移除
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style scoped lang="less">
.fade-enter-active {
  animation: fade-in 0.3s ease;
}
.fade-leave-active {
  animation: fade-out 0.3s ease;
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.message {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 999;
  min-width: 300px;
  height: 64px;
  line-height: 64px;
  color: #fff;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  transform: translate(-50%, -50%);
}
.info {
  background-color: rgba(0, 0, 0, 0.6);
}
.success {
  background-color: rgba(0, 255, 255, 0.5);
}
.warning {
  background-color: rgba(0, 0, 0, 0);
}
.error {
  background-color: rgba(0, 0, 0, 0);
}
</style>
